import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {PageSubscriber} from '~shared/models/wiki';

import {Subscriber} from '~shared/schema/wiki/actions/page-subscribers';

import {getSubscribers, addSubscribers, deleteSubscriber} from './thunks';

export interface SubscribersState {
    entities: Record<PageSubscriber['id'], PageSubscriber>;
    isLoading?: boolean;
    pageId?: number;
}

const initialState: SubscribersState = {
    isLoading: true,
    entities: {},
};

interface SetLoadingPayload {
    isLoading: boolean;
}

const setSubscribersDetails = (state: SubscribersState, subscriber: Subscriber) => {
    state.entities[subscriber.id] = Object.assign({}, state.entities[subscriber.id], {
        user: subscriber.user,
        isCluster: subscriber.is_cluster,
        id: subscriber.id,
    });
};

const {reducer, actions} = createSlice({
    name: 'subscribers',
    initialState,
    reducers: {
        setLoading(state, {payload: {isLoading}}: PayloadAction<SetLoadingPayload>) {
            state.isLoading = isLoading;
        },
    },
    extraReducers: (builder) => {
        function startLoading(state: SubscribersState) {
            state.isLoading = true;
        }
        function stopLoading(state: SubscribersState) {
            state.isLoading = false;
        }
        return builder
            .addCase(getSubscribers.pending, startLoading)
            .addCase(getSubscribers.fulfilled, (state, {payload}) => {
                const {results} = payload;

                results.forEach((subscriber) => {
                    setSubscribersDetails(state, subscriber);
                });
                state.isLoading = false;
            })
            .addCase(getSubscribers.rejected, stopLoading)
            .addCase(addSubscribers.pending, startLoading)
            .addCase(addSubscribers.fulfilled, (state, action) => {
                const {results} = action.payload;

                results.forEach((subscriber) => {
                    setSubscribersDetails(state, subscriber);
                });
                state.isLoading = false;
            })
            .addCase(addSubscribers.rejected, stopLoading)
            .addCase(deleteSubscriber.pending, startLoading)
            .addCase(deleteSubscriber.rejected, stopLoading)
            .addCase(deleteSubscriber.fulfilled, stopLoading);
    },
});

export {actions, reducer};
